import {
  Boolean,
  Dictionary,
  Optional,
  Record as RRecord,
  Static,
  String,
} from "runtypes";

import { KernelExecutorLiteral } from "../enums";

export const CircuitBreakerRequest = RRecord({
  executor: KernelExecutorLiteral,
  // If activate is true, then the sidecar is requesting that the circuit
  // breaker is enabled.
  activate: Boolean,
  // The reason why the request was activated
  activationReason: Optional(Dictionary(String)),
});

export type CircuitBreakerRequest = Static<typeof CircuitBreakerRequest>;
